import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { humanize } from 'humanize-duration';

@Pipe({
    name: 'analyticalTestDuration'
})
export class AnalyticalTestDurationPipe implements PipeTransform {

    transform(value: any, args?: any): any {

        const duration = moment.duration(value);

        if (!this.durationIsValid(value)) {
            return 'Please contact our office';
        }

        return humanize(duration.asMilliseconds(), { units: ['d'], spacer: ' work ' });

    }

    durationIsValid(iso8601DurationString) {
        if (iso8601DurationString === 'P0D') {
            return true;
        }
        ;
        return moment.duration(iso8601DurationString).toISOString() !== 'P0D';
    }


}
